<template>
  <el-row :gutter="15" class="wrapper">
    <template v-for="(state) in [
        'wait_confirm_make_plate',
        'making_plate',
      ]">
      <el-col :md="6" :key="state">
        <div class="card section">
          <p class="page-title">{{$t(`productDesign.states.${state}`)}}</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'product_designs.index', query: { state_in: [state] } }">
                <p class="value">{{ data[`product_design_${state}_count`] || 0 }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
    </template>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">待完成</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'product_designs.index', query: { state_in: ['make_plate_completed'], plate_making_type_eq: 'paper_pattern' } }">
              <p class="value">{{ data[`product_design_${state}_count`] || 0 }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class PatternMakerHome extends Vue {
  data = {};

  async mounted() {
    this.data = await this.$request.get('/dashboard/pattern_maker')
  }
}
</script>
